/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";

import { Modal, Card, Table, message, Form, Button } from "antd";
import { Row, Col, Space, Spin, Flex, Checkbox } from "antd";
import { TbFileCertificate, TbTags } from "react-icons/tb";

export default function ModalJO({ show,values, close, jocode }) {
  const [openModal, setOpenModel] = useState(show);
  const [loading, setLoading] = useState(true);

  /** handle logic component */
  const handleClose = () => {
    setTimeout(() => {
      close(false);
    }, 150);

    //setTimeout( () => close(false), 200 );
  };

   useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        // console.log(values);
        setLoading(false);
      }, 400);
  }, []);

  const handlePlPrint = (v) => {
    if (!v?.code_detail) {
      message.error("ไม่พบข้อมูลสำหรับพิมพ์ Packing Information");
      return;
    }
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/pl-pg-print/${v.code_detail}`;
    close(false);
  };

  /* ใบสั่งงานปิดฉลาก ใช้ code เดียวกับ Packing Information
     (er_jo_ver_detail.code ของรายการสินค้าที่กดมา) */
  const handleLabelPrint = (v) => {
    if (!v?.code_detail) {
      message.error("ไม่พบข้อมูลสำหรับพิมพ์ใบสั่งงานปิดฉลาก");
      return;
    }
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/jo-label-print/${v.code_detail}`;
    close(false);
  };

  /** setting child component */
  const ButtonModal = (
    <Space direction="horizontal" size="middle">
      {/* <Button onClick={() => handleClose()}>ปิด</Button> */}
    </Space>
  );

  return (
    <>
      <Modal
        open={openModal}
        title="เลือกแบบฟอร์ม"
        afterClose={() => handleClose()}
        onCancel={() => setOpenModel(false)}
        footer={ButtonModal}
        maskClosable={false}
        style={{ top: 20 }}
        width={400}
        className="modal-material"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Flex gap="small" vertical>
                <Button
                  style={{ width: 300 }}
                  className="bn-center bn-success-outline bn-bold bn-action"
                  size="small"
                  icon={<TbFileCertificate />}
                  onClick={() => handlePlPrint(values)}
                >
                  {" "}
                  Packing Information PG
                </Button>
                <Button
                  style={{ width: 300 }}
                  className="bn-center bn-primary-outline bn-bold bn-action"
                  size="small"
                  icon={<TbTags />}
                  onClick={() => handleLabelPrint(values)}
                >
                  {" "}
                  ใบสั่งงานปิดฉลาก
                </Button>
              </Flex>
            </Card>
          </Space>
        </Spin>
      </Modal>
    </>
  );
}
